import React from 'react'
import styles from './influencerSec.module.css'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import useTextAnimation from "../../hooks/useTextAnimation.js";
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant';

const InfluencerAchived = ({ influencerData }) => {
    const { ref: headingRef, inView: headingInView, textAnimation } = useTextAnimation();
    const { ref: paragraphRef, inView: paragraphInView } = useTextAnimation();
    const { t, i18n } = useTranslation();
    return (
        <div className={styles.InfluencerAchivedSec}>
            <div className={styles.InfluencerAchivedSec_inner}>
                <motion.div className={styles.InfluencerAchivedSec_title}
                    ref={headingRef}
                    initial="hidden"
                    animate={headingInView ? "visible" : "hidden"}
                    custom={0}
                    variants={textAnimation}
                >
                    {/* <h3>{t('What We Have Achieved WITH THE POWER OF INFLUENCERS')} </h3> */}
                    <h3>{t('whatWeHaveAchieved')} <br /> {t('powerOfInfluencers')}</h3>
                </motion.div>
                <motion.div className={styles.InfluencerAchivedSec_Stitle}
                    ref={paragraphRef}
                    initial="hidden"
                    animate={paragraphInView ? "visible" : "hidden"}
                    custom={1}
                    variants={textAnimation}
                >
                    {/* <p>We work closely with our clients in order to meet their needs whether it’s by spreading awareness on their latest news or building their engagement and audience.</p> */}
                    {/*  <p dangerouslySetInnerHTML={{ __html: influencerData?.achievedDescription }}></p> */}
                    <p dangerouslySetInnerHTML={{
                        __html: i18n.language === LANG_EN
                            ? influencerData?.achievedDescription
                            : influencerData?.achievedDescriptionAr
                    }}></p>
                </motion.div>

                <div className={styles.InfluencerAchivedSec_counts}>
                    <motion.ul className={`${styles.InfluencerAchivedSec_countL} ${i18n.language === LANG_AR ? 'arab' : ''}`}
                        ref={paragraphRef}
                        initial="hidden"
                        animate={paragraphInView ? "visible" : "hidden"}
                        custom={2}
                        variants={textAnimation}
                    >
                        <li>
                            <div className={styles.InfluencerAchivedSec_count}>
                                {/*  <h2>1000+</h2> */}
                                <h2>{influencerData?.campaignValueAch}</h2>
                                {/* <h3>Campaigns</h3> */}
                                {/*  <h3>{influencerData?.campaignTitleAch}</h3> */}
                                <h3>{i18n.language === LANG_EN ? influencerData?.campaignTitleAch : influencerData?.campaignTitleAchAr}</h3>
                                {/* <p>We create strategic, results-driven campaigns that cut through the noise and drive real impact.</p> */}
                                {/* <p dangerouslySetInnerHTML={{__html : influencerData?.campaignDescAch}}></p> */}
                               {/*  <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? influencerData?.campaignDescAch : influencerData?.campaignDescAchAr }}></p> */}
                            </div>
                        </li>
                        <li>
                            <div className={styles.InfluencerAchivedSec_count}>
                                {/*  <h2>1400+</h2>
                                <h3>Influencer Partnership</h3>
                                <p>Our trusted network of influencers turns brand messages into authentic conversations that matter.</p> */}
                                <h2>{influencerData?.totalInfluencers}</h2>
                                {/* <h3>{influencerData?.influencerTitle}</h3> */}
                                <h3>{i18n.language === LANG_EN ? influencerData?.influencerTitle : influencerData?.influencerTitleAr}</h3>
                                {/* <p dangerouslySetInnerHTML={{__html : influencerData?.influencerDesc}}></p> */}
                               {/*  <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? influencerData?.influencerDesc : influencerData?.influencerDescAr }}></p> */}
                            </div>
                        </li>
                        <li>
                            <div className={styles.InfluencerAchivedSec_count}>
                                {/*  <h2>1B+</h2>
                                <h3>Views</h3>
                                <p>More than just numbers, our campaigns prove the power of B2B influencer marketing and high-impact storytelling.</p> */}
                                <h2>{influencerData?.totalViews}</h2>
                                {/* <h3>{influencerData?.viewTitle}</h3> */}
                                <h3>{i18n.language === LANG_EN ? influencerData?.viewTitle : influencerData?.viewTitleAr}</h3>
                                {/* <p dangerouslySetInnerHTML={{__html : influencerData?.viewDesc}}></p> */}
                                {/* <p dangerouslySetInnerHTML={{ __html: i18n.language === LANG_EN ? influencerData?.viewDesc : influencerData?.viewDescAr }}></p> */}
                            </div>
                        </li>
                    </motion.ul>
                </div>
            </div>
        </div>
    )
}

export default InfluencerAchived
